import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import BusinessHours from '.';
import OnboardingAvailability from '../onboarding/OnboardingAvailability';
import type { AboutBusinessHoursProps } from './BusinessHours';
import {
  BodyText,
  Stack,
  Touchable,
} from '../../../ui';

export type EditableBusinessHoursProps = AboutBusinessHoursProps & {
  onEdit: () => void;
};

const EditableBusinessHours: React.FCWithChildren<EditableBusinessHoursProps> = ({
  schedule,
  centered,
  onEdit,
}) => {
  const needsAvailability = schedule && !schedule.find(s => !s.closed);

  return needsAvailability ? (
    <OnboardingAvailability onEdit={onEdit} />
  ) : (
    <Stack alignItems={centered ? 'center' : undefined}>
      <BusinessHours schedule={schedule} centered={centered} />
      <Inline>
        <Touchable
          onClick={onEdit}
          testID="manageAvailabilityLink"
        >
          <Box paddingY={12}>
            <BodyText
              appearance="smaller"
              color={BrandColor.FloraDark}
              textTransform="uppercase"
              weight="bold"
            >
              Manage Availability
            </BodyText>
          </Box>
        </Touchable>
      </Inline>
    </Stack>
  );
};

export default EditableBusinessHours;
